export default "/dist/files/icone_courrier.73614e65f88d46a4416753d24fa5539e.svg";